// src/components/DashBoard/DashBoard.jsx
import React from "react";
import ResumoCards from "./ResumoCards";
import ChamadosPorMes from "./ChamadosPorMes";
import ChamadosPorMotivo from "./ChamadosPorMotivo";
import ChamadosPorCliente from "./ChamadosPorCliente";
import ChamadosPorUsuario from "./ChamadosPorUsuario";
import Rodape from "../../pages/rodape/Rodape"; // importa rodapé

export default function DashBoard() {
  const handleAtualizar = () => {
    // 🔹 Aqui você pode recarregar os dados ou dar um reload simples
    window.location.reload();
  };

  return (
    <div className="p-6">
      {/* Breadcrumb + Botão */}
      <div className="flex items-center justify-between mb-4">
        <nav className="flex items-center space-x-3 text-sm">
          <span className="font-medium text-slate-700">Tela de DashBoard</span>
          <span className="text-slate-500">/</span>
          <span className="text-slate-700 font-medium">DashBoard</span>
        </nav>

        {/* Botão Atualizar */}
        <button
          onClick={handleAtualizar}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md shadow hover:bg-blue-700 transition"
        >
          Atualizar Dashboard
        </button>
      </div>

      {/* Linha preta fina e larga */}
      <div className="w-full">
        <hr className="border-t border-black w-[98%] mx-auto mb-6" />
      </div>

      {/* Texto de introdução simples */}
      <p className="text-gray-700 text-sm leading-relaxed mb-6">
        Esta tela tem como finalidade{" "}
        <span className="font-semibold">
          auxiliar na análise e controle de chamados, atendimentos e indicadores
          de desempenho
        </span>
        , oferecendo uma visão consolidada para monitoramento e suporte à tomada
        de decisão.
      </p>

      {/* Cards de resumo */}
      <ResumoCards />

      {/* Gráficos lado a lado */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <ChamadosPorMes />
        <ChamadosPorMotivo />
      </div>

      {/* Gráficos lado a lado */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <ChamadosPorCliente />
        <ChamadosPorUsuario />
      </div>

      {/* Rodapé no final */}
      <div className="mt-10">
        <Rodape />
      </div>
    </div>
  );
}
